import React, { Component } from 'react';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';

import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import { FileSelection } from '../../containers/Files'
import { AlertJsMessage } from './../../helpers.js'


/**
 * Form
 */

const CATEGORY_TYPES = [
  { key: 'workout', name: 'Workouts' },
  { key: 'program', name: 'Programs' },
  { key: 'block', name: 'Blocks' },
  { key: 'equipment', name: 'Exercise Equipment' },
  { key: 'body-part', name: 'Exercise Subcategory' }
]
export class Form extends Component { // eslint-disable-line react/prefer-stateless-function
  state = {
    type: 'workout',
    editCat: null,
    newCatName: '',
    dataLoaded: false
  }
  componentDidMount() {
    if (!this.state.dataLoaded) {
      this.props.fetchAll().then(() => {
        this.setState({
          ...this.state,
          dataLoaded: true
        })
      });
    }
  }
  edit(cat) {
    this.setState({
      ...this.state,
      editCat: cat,
      newCatName: cat.name
    })
  }
  handleNameChange(e) {
    this.setState({
      ...this.state,
      newCatName: e.target.value
    })
  }
  validateForm() {
    const { type, selectedFile, previewVideoSrc, previewImageSrc } = this.fileSelect.state;
    if (type === 'library') {
      if (selectedFile) {
        this.submitValidatedForm(selectedFile);
      } else {
        AlertJsMessage("Please select a video or image for the cover.");
        return;
      }
    } else if (type === 'upload') {
      if (previewVideoSrc || previewImageSrc) {
        this.setState({
          ...this.state,
          isValidating: true
        }, () => {
          this.fileSelect.submitNewFile().then((file) => {
            this.submitValidatedForm(file);
          })
        })

      } else {
        AlertJsMessage("Please upload a video or image for the cover.")
      }
    } else {
      AlertJsMessage("Please select or upload a cover video or image for the cover.");
    }
  }
  submitValidatedForm(file) {
    const { create, update } = this.props;
    const { type, editCat, newCatName } = this.state;
    var formData = {
      ...editCat,
      name: newCatName
    };
    formData.fileId = file._id;
    if (file.fileType === 'mp4') {
      formData.videoUrl = file.url;
    } else {
      formData.imgUrl = file.url;
    }
    if (editCat) {
      update(formData).then((response) => {
        this.clear();
      })
    } else {
      create({
        type: type,
        ...formData
      }).then((response) => {
        this.clear();
      })
    }
  }
  clear() {
    this.setState({
      ...this.state,
      newCatName: '',
      editCat: null
    })
  }
  render() {
    const { type, editCat, newCatName, dataLoaded } = this.state;
    const { user } = this.props;
    if (dataLoaded) {
      const categories = Object.values(this.props.categories).filter((cat) => cat.type === type);
      return (
        <div>
          <h1>Manage Categories</h1>
          <ToggleButtonGroup
            value={type}
            onChange={(event, type) => this.setState({ ...this.state, type: type })}
            exclusive>
            {
              CATEGORY_TYPES.map((cat) => (
                <ToggleButton key={cat.key} value={cat.key} selected={type === cat.key}>
                  {cat.name}
                </ToggleButton>
              ))
            }
          </ToggleButtonGroup>

          <TextField
            label={editCat ? `${editCat.fileId} - ${editCat.id}` : `Add New Category`}
            value={newCatName}
            onChange={(e) => this.handleNameChange(e)}
            margin="dense"
            variant="outlined"
          />
          <FileSelection
            userData={user}
            fileType="image"
            category="programCover"
            selectedFileId={editCat ? editCat.fileId : 0}
            ref={(ref) => { this.fileSelect = ref ? ref.getWrappedInstance() : null }}
          />
          <br />
          <Button
            disabled={newCatName ? false : true}
            onClick={() => this.validateForm()}
            variant="contained" color="primary">
            {editCat ? 'Update' : "Create"}
          </Button>
          <Button onClick={() => this.clear()}
            variant="contained" color="default">
            Cancel
          </Button>
          <ul>
            {
              categories.map((cat) => (
                <li key={cat.id}>
                  <img alt="" src={cat.imgUrl ? cat.imgUrl : ""} width={50} />
                  {cat.name}
                  <IconButton onClick={(e) => this.edit(cat)}>
                    <EditIcon fontSize="small" />
                  </IconButton>
                </li>
              ))
            }
          </ul>

        </div>
      );
    }
    return null;
  }
}

export default Form;



// WEBPACK FOOTER //
// ./src/components/categories/Form.js